import { merge } from 'lodash/fp';

import defaultTheme from '@ihme/common/theme/default';

export default merge(defaultTheme, {
    // add theme overrides here
});
